<template>
  <div>
    <div v-if="debug_show_page_name == true" style="color: green">
      page_0080_system_setting
    </div>
    <app-header>esma</app-header>
    <div :class="'container ' + pageContainerSize">
      <title-and-slot title="ブラウザ設定">
        <div></div>
      </title-and-slot>

      <div class="row" style="margin-bottom: 10px">
        <div class="col-xs-4">
          <button class="btn btn-primary"
            style=" width: 25%; float: left; margin-left: -25px; min-width: 100px; "
            @click="goBack" > ＜　戻る </button>
        </div>
      </div>
      <div class="row" style="margin-bottom: 10px">
        <div class="col-xs-4" style="">
          <!-- Coll A -->
          <field-box
            v-for="f in formFields.col1"
            v-bind:key="f.id"
            v-bind:data="f"
            :read="readOnly"
            :val="values[f.id]"
          ></field-box>
        </div>
      </div>
      <div class="col-xs-4" style="">
        <div class="row" style="margin-bottom: 10px">
          <button
            v-if="read_only == false"
            class="btn btn-primary"
            style="
              min-width: 100px;
              float: right;
              margin-left: 10px;
              margin-right: 5px;
              background: #92d050;
              border-color: #92d050;
            "
            @click="onSave"
          >
            登録
          </button>
          <button
            v-if="read_only == true"
            class="btn btn-primary"
            style="
              min-width: 100px;
              float: right;
              margin-left: 10px;
              margin-right: 5px;
            "
            @click="onEdit"
          >
            編集
          </button>
          <button
            v-if="read_only == false"
            class="btn btn-primary"
            style="
              min-width: 100px;
              float: right;
              margin-left: 10px;
              background: #a6a6a6;
              border-color: #a6a6a6;
            "
            @click="btnCancel"
          >
            キャンセル
          </button>
        </div>
      </div>
     <!-- <div id="page_content" 
      style="border: solid black 1px; width: 100%;margin-top:150px;height:20px;padding:15px;"></div>-->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { fields, filed_types } from "@/rules/fields_system_setting";
import { utils } from "@/libs/utils";
import _debug from "debug";
var mdebug = _debug("esma:master_belong_details");
import fieldBoxes from "@/components/form-field";
import acl from "@/rules/acl_rules";
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import { bus } from "@/libs/bus";
export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {
    "field-box": fieldBoxes,
  },
  data() {
    return {
      api_name: "system_setting",
      page_acl: acl.maintenance,
    };
  },
  computed: {
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1: [
          {
            id: "page_size",
            label: "ページサイズ",
            type: "select",
            options: ["80%", "90%", "100%", "110%", "120%", "130%", "140%"],
          },
          {
            id: "table_size",
            label: "テーブルサイズ",
            type: "select",
            options: [
              "1020",
              "1120",
              "1220",
              "1320",
              "1420",
              "1520",
              "1620",
              "1720",
              "1820",
            ],
          },
        ],
      };
    },
  },
  methods: {
    onSave() {
      this.read_only = true;
      if (this.$store.state[this.stateCurrentEditing]) {
        var save_to_db = {
          pageContainerSize:localStorage.getItem("pageContainerSize"),
          pageZoom:localStorage.getItem("pageZoom")
        }
        if (this.$store.state[this.stateCurrentEditing].table_size) {
          localStorage.setItem( "pageContainerSize", this.$store.state[this.stateCurrentEditing].table_size );
          save_to_db["pageContainerSize"] =this.$store.state[this.stateCurrentEditing].table_size
          this.$store.state[ this.stateCurrentRow ].table_size = this.$store.state[this.stateCurrentEditing].table_size;
          this.pageContainerSize = this.$store.state[ this.stateCurrentEditing ].table_size;
        }
        if (this.$store.state[this.stateCurrentEditing].page_size) {
          var page_size = this.$store.state[this.stateCurrentEditing].page_size;
          page_size = parseInt(page_size.replace("%", "")) / 100;
          localStorage.setItem("pageZoom", page_size);
          save_to_db["pageZoom"] = page_size;
          this.$store.state[this.stateCurrentRow].page_size = this.$store.state[ this.stateCurrentEditing ].page_size;

            //ズームサイズ
            // var z = 0.5;
            var mb = document.getElementById('main-body');

            //ウィンドウ幅を取得
            var iw = window.innerWidth;

            //ズームを適用
            mb.style.zoom = page_size;
            //幅を適用
            if(page_size < 1){
              mb.style.minWidth = parseInt(iw/page_size) + "px";
              mb.style.maxWidth = null
            }else{
              mb.style.minWidth = null;
              mb.style.maxWidth = parseInt(iw/page_size) + "px";
            }

          // document.querySelectorAll(".container")[0].style.zoom = page_size;
        }
        if(save_to_db.pageZoom || save_to_db.pageContainerSize){
          this.$ajax.post("/master_user/save_browser_settings", {changes:{zoom_info:JSON.stringify(save_to_db)}}, (err, result) => {
            if(err){
              this.$notify({
                title: 'データの処理に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
            }else{
              this.$notify({
                title: 'データ処理が完了しました。',
                type: 'info',
                duration: 2000
              });
            }
          })
        }
      }
      setTimeout(()=>{
        // this.goBack();
      },500)
    },
    onEdit() {
      mdebug("onEdit");
      this.commonOnEdit();
    },
    btnCancel() {
      this.cancelCurrentSelection(true);
    },
    goBack(){
      var broser_setting_back_to = window.sessionStorage.getItem("broser_setting_back_to")
      return this.$router.push(broser_setting_back_to);
    },
  },
  mounted() {
    var pageZoom = localStorage.getItem("pageZoom") || 1;
    var pageContainerSize = localStorage.getItem("pageContainerSize") || 1420;
    this.$store.state[this.stateCurrentRow] = {
      page_size: parseInt(pageZoom * 100) + "%",
      table_size: pageContainerSize + "",
    };
  },
  beforeDestroy() {},
  beforeMount() {},
};
</script>
<style scoped>
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>


// WEBPACK FOOTER //
// page_0080_browser_setting_detail.vue?2f8b2117